export default __webpack_public_path__ + "static/media/navigation.b6c91e1f.svg";